import { useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import { baseURL, useFetch } from "../../../custom/api";
import ChallengeProgress from "./ChallengeProgress";
import ChallengeRules from "./ChallengeRules";
import "../../../styles/Banners.css";
import "../../../styles/Challenges.css";

// One flexible banner, state-driven (spec: "one component, not 11 designs").
// Home already sits behind ProtectedRoutes, so a real user is always present
// here - there is no genuine anonymous state to render inside the app.
function ChallengeBanner() {
  const { myFetch } = useFetch();
  const [entry, setEntry] = useState(undefined); // undefined = loading, null = nothing to show
  const [progress, setProgress] = useState(null);
  const [showRules, setShowRules] = useState(false);

  const loadList = useCallback(async () => {
    const resp = await myFetch("challenges", { method: "GET" });
    const list = await resp.json();
    setEntry(Array.isArray(list) && list.length > 0 ? list[0] : null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    loadList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadProgress = useCallback(async (challengeId) => {
    const resp = await myFetch(`challenges/${challengeId}/progress`, { method: "GET" });
    const r = await resp.json();
    if (r.status === "success") setProgress(r);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (entry && entry.participation) {
      loadProgress(entry.challenge.challenge_id);
    } else {
      setProgress(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [entry?.challenge?.challenge_id, entry?.participation?.status]);

  if (!entry) return null; // still loading, or genuinely no challenge to show

  const { challenge, participation } = entry;

  const handleChanged = () => {
    loadList();
    loadProgress(challenge.challenge_id);
  };

  if (!participation) {
    return (
      <>
        <div className="challengeBannerCard">
          <div className="challengeBannerTopRow">
            <div className="challengeBannerText">
              <p className="heading-3 white">{challenge.title}</p>
              <p className="yekan caption-1 white">{challenge.short_description}</p>
            </div>
            {challenge.banner_image && (
              <img
                src={`${baseURL}/${challenge.banner_image}`}
                alt={challenge.title}
                className="challengeBannerImg"
              />
            )}
          </div>
          <div className="challengeBannerCtaRow marginTop1r">
            <Link
              to={`/challenges/${challenge.challenge_id}`}
              className="challengeBannerCta challengeBannerCtaMain"
            >
              شروع چالش
            </Link>
            <div className="challengeBannerCtaIcon">
              <button
                type="button"
                className="challengeInfoButton icon-iconinfo"
                aria-label="قوانین چالش"
                onClick={() => setShowRules(true)}
              ></button>
            </div>
          </div>
        </div>
        <ChallengeRules show={showRules} onClose={() => setShowRules(false)} challenge={challenge} />
      </>
    );
  }

  return (
    <div>
      <div className="spc-between marginBottom1r">
        <Link to={`/challenges/${challenge.challenge_id}`} className="caption-1 purple-1">
          مشاهده کامل ‹
        </Link>
        <span className="caption-1 grey-2">چالش فعال</span>
      </div>
      {progress ? (
        <ChallengeProgress
          challenge={progress.challenge}
          participation={progress.participation}
          progress={progress.progress}
          compact
          onChanged={handleChanged}
        />
      ) : null}
    </div>
  );
}

export default ChallengeBanner;
